import { Pipe, PipeTransform } from '@angular/core'
import _ from 'lodash'

@Pipe({ name: 'displayName' })
export class DisplayNamePipe implements PipeTransform {
    transform(subject: any, withId?: boolean): string {
        if (!subject || !subject.opsubType) {
            return ''
        }

        let name = null
        let ident = null

        if (subject.opsubType === 'OFO' || subject.opsubType === 'FO') {
            let words = []

            if (subject.prijmeni) {
                words.push(subject.prijmeni)
            }

            if (subject.jmeno) {
                words.push(subject.jmeno)
            }

            if (!_.isEmpty(words)) {
                name = words.join(' ')
            }

            let titles = []

            if (subject.titulPredJmenem) {
                titles.push(subject.titulPredJmenem)
            }

            if (subject.titulZaJmenem) {
                titles.push(subject.titulZaJmenem)
            }

            if (!_.isEmpty(titles)) {
                name = name + ', ' + titles.join(' ')
            }

            if (subject.opsubType === 'OFO' && subject.rodneCislo) {
                ident = 'RČ ' + subject.rodneCislo
            } else if (subject.ico) {
                ident = 'IČ ' + subject.ico
            }
        } else if (subject.opsubType === 'SJM') {
            name = 'SJM'

            if (subject.nazev) {
                name += ' ' + subject.nazev
            }
        } else {
            if (subject.nazev) {
                name = subject.nazev
            }

            if (subject.ico) {
                ident = 'IČ ' + subject.ico
            }
        }

        if (!name) {
            name = '—'
        }

        if (withId && ident) {
            return name + ' (' + ident + ')'
        }

        return name
    }
}
